import React, { useEffect, useRef, useState } from 'react'
import loadImage from 'blueimp-load-image/js'
import ReactCrop from 'react-image-crop'
import cropStyle from '!!raw-loader!react-image-crop/dist/ReactCrop.css'
import Button from './UI/Button'
import Title from './UI/Title'
import { FiArrowLeft } from 'react-icons/fi'

const Uploader = ({ setPhoto, reset }) => {
  const trigger = useRef()
  const [imgRef, setImgRef] = useState(null)
  const [upload, setUpload] = useState(null)
  const [crop, setCrop] = useState({})

  useEffect(() => {
    if (trigger.current && !upload) trigger.current.click()
  }, [trigger])

  const onSelectFile = e => {
    const input = e.target
    if (input.files && input.files.length > 0) {
      loadImage(
        input.files[0],
        img => {
          setUpload(img.toDataURL('image/jpeg', 0.8))
          input.value = ''
        },
        {
          orientation: true,
          canvas: true
        }
      )
    }
  }

  const onLoad = image => {
    setImgRef(image)
    setTimeout(() => {
      const width = image.width > image.height ? image.height : image.width
      const height = image.height > image.width ? image.width : image.height
      const x = width === image.width ? 0 : (image.width - width) / 2
      const y = height === image.height ? 0 : (image.height - height) / 2
      setCrop({ unit: 'px', aspect: 1, width, height, x, y })
    }, 100)
    return false
  }

  const renderCrop = async (image, crop) => {
    const canvas = document.createElement('canvas')
    const scaleX = image.naturalWidth / image.width
    const scaleY = image.naturalHeight / image.height
    const lowerRatio = Math.max((crop.width * scaleX) / 1500, 1)
    console.log(scaleX, scaleY, crop.width, crop.height, lowerRatio)
    canvas.width = (crop.width * scaleX) / lowerRatio
    canvas.height = (crop.height * scaleX) / lowerRatio
    const ctx = canvas.getContext('2d')
    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      (crop.width * scaleX) / lowerRatio,
      (crop.height * scaleY) / lowerRatio
    )
    setUpload(null)
    setImgRef(null)
    setCrop({})
    setPhoto(canvas.toDataURL('image/jpeg', 0.7), canvas.width)
  }

  return (
    <div className="flex flex-col justify-center items-center w-full h-screen lg:max-w-5xl mx-auto p-4 lg:p-6 pb-16 lg:pb-32 ">
      <input
        accept="image/*"
        onChange={onSelectFile}
        ref={trigger}
        style={{ position: 'fixed', visibility: 'hidden' }}
        type="file" />
      <div className="fixed top-0 left-0 p-4">
        <Button onClick={reset} Icon={FiArrowLeft} variant="icon" />
      </div>

      {!upload &&
        <div style={{ margin: 30, display: 'flex' }}>
          <Button style={{ margin: 10 }} onClick={() => trigger.current.click()}>Choisir une photo</Button>
        </div>
      }
      {upload && (
        <div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Title className="my-4 lg:my-6 px-10">Je recadre ma photo</Title>
            <style dangerouslySetInnerHTML={{ __html: cropStyle }} />
            <div className="flex justify-center" style={{ width: (imgRef && imgRef.width > imgRef.height) ? '80vw' : '45vh', maxWidth: 900, position: 'relative' }}>
              <ReactCrop
                crop={crop}
                keepSelection
                onChange={c => setCrop(c)}
                onImageLoaded={onLoad}
                ruleOfThirds
                src={upload} />
            </div>
            <Button onClick={() => renderCrop(imgRef, crop)} className="my-4 lg:my-6">
              Valider
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}

export default Uploader
